import useSWRImmutable from 'swr'
import fetcher from './fetcher'

export default function useBalanceSheet(id) {
  const { data, error, isLoading } = useSWRImmutable(`/react/balance_sheets?stock_id=${id}`, fetcher)

  return {
    balanceSheet: data,
    isLoading,
    error
  }
}